// frontend/src/services/transactionService.js
import api from './apiService';

/**
 * Busca a lista de transações, faturas e projeções para um determinado mês/ano.
 */
export const getTransacoes = async (params) => {
    const response = await api.get('/financeiro/transacoes/', { params });
    return response.data;
};

/**
 * Busca os detalhes de uma única transação pelo seu ID.
 */
export const getTransacaoById = async (id) => {
    const response = await api.get(`/financeiro/transacoes/${id}/`);
    return response.data;
};

/**
 * Cria uma nova transação (despesa, receita ou transferência).
 */
export const createTransacao = async (transacaoData) => {
    const response = await api.post('/financeiro/transacoes/', transacaoData);
    return response.data;
};

/**
 * Atualiza uma transação existente.
 * Usado para editar lançamentos à vista, entre outros.
 */
export const updateTransacao = async (id, payload) => {
    // Usando PATCH para permitir atualizações parciais
    const response = await api.patch(`financeiro/transacoes/${id}/`, payload);
    return response.data;
};

/**
 * Exclui uma transação.
 */
export const deleteTransacao = async (id) => {
    await api.delete(`/financeiro/transacoes/${id}/`);
};

/**
 * Marca uma transação pendente como 'paga', atualizando seu status e data de pagamento.
 */
export const marcarTransacaoComoPaga = async (id, pagamentoData) => {
    const response = await api.post(`/financeiro/transacoes/${id}/marcar_como_pago/`, pagamentoData);
    return response.data;
};

/**
 * Reverte o status de uma transação de 'paga' para 'pendente'.
 */
export const reverterTransacaoParaPendente = async (id) => {
    const response = await api.post(`/financeiro/transacoes/${id}/reverter_para_pendente/`);
    return response.data;
};

/**
 * Obtém o token e a URL pública do card de cobrança para compartilhar no WhatsApp.
 * Retorna { token, url }.
 */
export const getCobrancaLink = async (transacaoId) => {
    const response = await api.get(`/financeiro/transacoes/${transacaoId}/cobranca-link/`);
    return response.data;
};

/**
 * Obtém o token e a URL pública do card de cobrança para projeção de recorrência.
 * dataVencimento: string ISO (YYYY-MM-DD), ex. transacao.data_original_ocorrencia ou transacao.data_vencimento.
 * Retorna { token, url }.
 */
export const getCobrancaLinkProjecao = async (recorrenciaId, dataVencimento) => {
    const dataStr = typeof dataVencimento === 'string' ? dataVencimento.split('T')[0] : dataVencimento;
    const response = await api.get(`/financeiro/recorrencias/${recorrenciaId}/cobranca-link/`, {
        params: { data_vencimento: dataStr }
    });
    return response.data;
};

/**
 * Cria um lançamento parcelado em conta (receita ou despesa).
 * Payload: { descricao, tipo, modo: 'valor_total'|'valor_parcela', valor_total?, valor_parcela?, total_parcelas, data_primeira_parcela, conta_id, categoria_id, marcar_primeira_como_pago?, data_pagamento? }
 */
export const createLancamentoParceladoConta = async (payload) => {
    const response = await api.post('/financeiro/lancamentos-parcelados-conta/', payload);
    return response.data;
};

/**
 * Busca o resumo de todos os parcelamentos do usuário (conta + cartão): parcelas pagas e valor restante.
 */
export const getResumoParcelamentos = async () => {
    const response = await api.get('/financeiro/parcelamentos/resumo/');
    return response.data;
};

// ===================================================================================
// INÍCIO DA ALTERAÇÃO: Função de exceção REMOVIDA
// ===================================================================================
// A função createRecorrenciaExcecao foi movida para recurrenceService.js
// ===================================================================================
// FIM DA ALTERAÇÃO
// ===================================================================================